import { RedirectToHome } from '../config';
import { BaseURL } from '../environment';
import { HTTP } from './services';

class LogoutService {

    async redirectToLogout(){
        
        // this method always return success:
            try {
               const response = await HTTP.GET(`${BaseURL}/logoutAndRedirect?url=${encodeURIComponent(BaseURL+process.env.PUBLIC_URL)}`);
               return response;
            }
            catch(e) {
                console.log(e, 'error')
                return true;
            }
    }
  
    async logout() {
        try{
            this.redirectToLogout().then(()=>RedirectToHome());
        }
        catch(e) {
            console.error(e.toString());
        }
    }
}

export  const  LogoutServices = new LogoutService();
export default LogoutServices;

